
import { Component, Vue, Prop } from "vue-property-decorator";

import {
  TTeammates_Case_Table,
  TTeammates_Select,
  TCase_Redistribution,
} from "@/models/company_teammates";

const VALUE_NAME = "name";
const VALUE_JOB_POSITION = "jobPosition";
const VALUE_TEAMMATE = "teammate";

@Component
export default class TeammatesPendingInvitesTable extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly cases!: TTeammates_Case_Table[];
  @Prop({ type: Array, default: () => [] }) readonly teammates!: TTeammates_Select[];
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;

  memberValue(case_id: number) {
    const teammateId = this.caseRedistribution.find((item) => item.case_id === case_id)?.user_id;

    const teammate = this.teammates.find((teammate) => teammate.value === teammateId)?.label;

    return teammate || "Select owner";
  }

  $refs!: {
    label: HTMLElement;
  };

  caseRedistribution: TCase_Redistribution[] = [];

  selectTeammate(case_id: number, user_id: number) {
    const isExist = this.caseRedistribution.find((item) => item.case_id === case_id);

    if (isExist)
      this.caseRedistribution = this.caseRedistribution.filter((item) => item.case_id !== case_id);

    this.caseRedistribution.push({
      case_id,
      user_id,
    });

    this.$emit("update", this.caseRedistribution);

    this.$refs.label.click();
  }

  get attributes() {
    const { headers, cases, loading } = this;
    return {
      headers,
      items: cases,
      loading,
    };
  }

  headers = [
    {
      text: this.$t("table.headers.openApplicationsFor"),
      value: VALUE_NAME,
      filterable: true,
      slot: true,
    },
    {
      text: this.$t("table.headers.jobPosition"),
      value: VALUE_JOB_POSITION,
      filterable: true,
    },
    {
      text: this.$t("table.headers.teammate"),
      value: VALUE_TEAMMATE,
      slot: true,
    },
  ];
}
